import {callAPI} from '@/store/utils';

export default {
  namespaced: true,
  state: {
    cardsList: [],
    companyAccounts: [],
    currentCard: null,
    budgetDetails: null,
  },
  mutations: {
    setCards(state, res) {
      state.cardsList = res?.result || res || [];
    },
    setCurrentCard(state, res) {
      state.currentCard = res?.result || res || null;
    },
    setCompanyAccounts(state, res) {
      state.companyAccounts = res?.result || res || null;
    },
    setBudgetDetails(state, res) {
      state.budgetDetails = res?.result || res || [];
    },
  },
  actions: {
    async actionGetCardsList({commit, rootState}) {
      const canViewAll = Boolean(
        rootState.user?.permissions?.manage_all_payment_cards,
      );
      const query = canViewAll ? '?view=all' : '';
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/cards${query}`,
      );
      commit('setCards', res);
      return res;
    },
    async actionGetCardById({commit, rootState}, cardId) {
      const res = await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/cards/${cardId}`,
      );
      commit('setCurrentCard', res);
      return res;
    },
    async actionCreateCard({rootState}, params) {
      const par = {
        card_type: 'individual_card',
        company_id: rootState.companyId,
        name: params.name,
        user_id: params.user_id,
      };

      return await callAPI('POST', `equals/cards`, {...par});
    },
    async actionChangeCardStatus({rootState}, params) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };

      return await callAPI(
        'POST',
        `equals/cards/${params.cardId}/transition`,
        payload,
      );
    },
    async actionReplaceCard({rootState}, params) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };

      return await callAPI(
        'POST',
        `equals/cards/${params.cardId}/replace`,
        payload,
      );
    },
    async actionConvertToPhysicalCard({rootState}, params) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };

      return await callAPI(
        'POST',
        `equals/cards/${params.cardId}/convert-to-physical`,
        payload,
      );
    },
    async actionSetPin({rootState}, params) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };
      return await callAPI('PUT', `equals/cards/${params.cardId}/pin`, payload);
    },
    async actionGetClientAccessToken(
      {rootState},
      {cardId, purpose, code = null, otp_id = null},
    ) {
      const payload = {
        purpose,
        ...(code ? {code} : {}),
        ...(otp_id ? {otp_id} : {}),
      };

      return await callAPI(
        'POST',
        `company/${rootState.companyId}/equals/cards/${cardId}/access-token`,
        payload,
      );
    },
    async actionPost3ds({rootState}, params = {}) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };
      const res = await callAPI('POST', `equals/3ds-validation`, payload);
      return res;
    },
    async actionGetCardTransactions({rootState}, params = {}) {
      const payload = {
        ...params,
        company_id: rootState.companyId,
      };

      return await callAPI(
        'POST',
        `equals/cards/${params.cardId}/transactions`,
        payload,
      );
    },
    async actionGetCardSpendingLimits({rootState}, cardId) {
      return await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/cards/${cardId}/spending-limits`,
      );
    },
    async actionUpdateCardSpendingLimit(
      {rootState},
      {cardId, cardLimitId, amount, limit_window, active},
    ) {
      const payload = {
        amount,
        ...(limit_window ? {limit_window} : {}),
        ...(typeof active === 'boolean' ? {active} : {}),
        company_id: rootState.companyId,
      };
      return await callAPI(
        'PUT',
        `company/${rootState.companyId}/equals/cards/${cardId}/spending-limits/${cardLimitId}`,
        payload,
      );
    },
    async actionGetCardTransactionLimits({rootState}, cardId) {
      return await callAPI(
        'GET',
        `company/${rootState.companyId}/equals/cards/${cardId}/transaction-limits`,
      );
    },
    async actionUpdateCardTransactionLimit(
      {rootState},
      {cardId, cardLimitId, amount, active},
    ) {
      const payload = {
        amount,
        ...(typeof active === 'boolean' ? {active} : {}),
        company_id: rootState.companyId,
      };
      return await callAPI(
        'PUT',
        `company/${rootState.companyId}/equals/cards/${cardId}/transaction-limits/${cardLimitId}`,
        payload,
      );
    },
  },
};
